import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12.01 10.66" {...props}><g data-name="Ebene 2"><g data-name="Ebene 1" fill="none" stroke="#999" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.7"><path d="M6.11 7.64V.85M6.11 7.64l2.71-2.93M3.56 4.67l2.55 2.97M3.56 2.21H.85v7.6h10.31v-7.6H8.99" /></g></g></svg>);